import { c as _c } from "react/compiler-runtime";
import React from "react";
export function InputLoadingIndicator(t0) {
  const $ = _c(5);
  const {
    showText: t1
  } = t0;
  const showText = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative flex gap-1"><div className="h-2 w-2 rounded-full bg-primary/80 animate-bounce [animation-delay:-0.3s]" /><div className="h-2 w-2 rounded-full bg-primary/80 animate-bounce [animation-delay:-0.15s]" /><div className="h-2 w-2 rounded-full bg-primary/80 animate-bounce" /></div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== showText) {
    t3 = showText && <span className="text-sm font-medium text-muted-foreground whitespace-nowrap">vif is thinking...</span>;
    $[1] = showText;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t3) {
    t4 = <div className="flex items-center gap-2 px-3 py-2 w-full">{t2}{t3}</div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}